import { ReactNode } from "react"

const Tooltip = ({
  text,
  children,
}: {
  text: string
  children: ReactNode
}) => (
  <span className="group relative inline-flex">
    {children}
    <span
      role="tooltip"
      className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-1.5 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-900 px-2.5 py-1 text-xs font-medium text-white opacity-0 shadow-lg transition-opacity group-hover:opacity-100"
    >
      {text}
    </span>
  </span>
)

export default Tooltip
